import { createChangeEmitter } from '@findify/change-emitter';

export default createChangeEmitter();
